import Homepage from '../containers/Homepage'
import Dashboard from '../containers/Dashboard'
import CustomerDashboard from '../containers/CustomerDashboard'
import CustomerPolicyDetail from '../containers/CustomerPolicyDetail'
import RegistrationList from '../components/Registration/RegistrationList'
import RedemptionList from '../components/Registration/RedemptionList'
import StoreList from '../components/Registration/StoreList'
import StaticStoreList from '../components/Registration/StaticStoreList'


export default {
  dashboard: {
    path: '/dashboard',
    name: 'Dashboard',
    redirect:'/dashboard/redemption',
    component: Dashboard,
    meta: { label: 'home.dashboard.header' },
    children: [
 {
    path: '/dashboard/registration',
    name: 'RegistrationList',
    component: RegistrationList,
    meta: { label: 'home.dashboard.header' }
  },
{
    path: '/dashboard/redemption',
    name: 'RedemptionList',
    component: RedemptionList,
    meta: { label: 'home.dashboard.header' }
  },
  {
    path: '/dashboard/store',
    name: 'StoreList',
    component: StoreList,
    meta: { label: 'home.dashboard.header' }
  },
   {
    path: '/dashboard/staticStore',
    name: 'StaticStoreList',
    component: StaticStoreList,
    meta: { label: 'home.dashboard.header' }
  }
  ]
  },
 
  clientDashboard: {
    name: 'Customer Dashboard',
    path: '/customer-dashboard',
    alias: '/dashboard',
    meta: { label: 'home.customerPolicy.header' },
    component: CustomerDashboard
  },
  clientPolicyDetail: {
    name: 'Customer Policy Detail',
    path: 'detail',
    props: true,
    meta: { label: 'home.customerPolicy.detail.header' },
    component: CustomerPolicyDetail
  }
}



// WEBPACK FOOTER //
// ./src/Homepage/route/index.js